
import React from "react";
import fields from "../../json/RoomSizeFields.json";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const AddRoomSizeForm = ({ values, errors, handleChange, handleSubmit, loading }) => {
  const { formdata } = fields
  return (
    <PageBody
      headerchildren={
        <HeadingOne>Create Room Size</HeadingOne>
      }
      onSubmit={handleSubmit}>
      {formdata.map((field) => (
        <FormInput
          key={field.name}
          field={field}
          value={values[field.name]}
          handleChange={handleChange}
          error={errors[field.name]}
        />
      ))}

      <FormSubmitButton
        label="Create"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default AddRoomSizeForm;
